module.exports = __webpack_public_path__ + "img/sec3_img_6.96744dc1.png";